import React, { Component } from 'react';
import { Grid, GridCell } from 'rmwc/Grid';
import { connect } from 'react-redux';
import {Button} from 'rmwc/Button';
import { Snackbar } from 'rmwc/Snackbar';
import { Typography } from 'rmwc/Typography';
import { Select } from 'rmwc/Select';
import { Link } from 'react-router-dom'
import { Card } from 'rmwc/Card';
import { TextField} from 'rmwc/TextField';
import * as api from '../../api/api';
import StatusMessage from '../../util/StatusMessage'
import { FormField } from 'rmwc/FormField';
import { ListDivider } from 'rmwc/List';
import {default as Reactsel} from 'react-select';
import StarRatings from 'react-star-ratings';
import {stateToHTML} from 'draft-js-export-html';
import { EditorState, ContentState, convertFromHTML } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';

class EditTaxonomy extends Component {
	constructor(props) {
		super(props)
    	this.state = {
    		data: {
    			taxonomyComboDropDown: [],
                productComboDropDown: [],
                topicComboDropDown: [],
                aspectComboDropDown: []
    		},
            editData: {
                taxonomyName: '',
                taxonomyTag: '',
                taxonomyImgLink: '',
                taxonomyDescription: '',
                taxonomyListingSequence: '',
                active: 1,
            },
            editorData: {
                htmlText: '',
                editorState: EditorState.createEmpty(),
                contentValue:'',
                contentState:'',
                editorStateRead:EditorState.createEmpty(),
            },
            productChange: false,
            taxonomyChange: false,
            topicChange: false,
            aspectChange: false,
            selectedTaxonomyParent: [],
            selectedProductList: [],
            selectedTopicList: [],
            selectedAspectList: [],
            errorMsg: ''
    	}
    }

    handleBackAction = (e) => {
        e.preventDefault()
        this.props.history.push(`/portal/app/admin/learning_taxonomies/${this.props.match.params.type}/${this.props.match.params.typeName}`)
    }


    handleActiveChange = evt => {
        let editData = Object.assign({}, this.state.editData)
        editData.active = evt.target.value
        this.setState({editData: editData})
  };
  

    handleTaxonomyNameChange = (event) => {
        let editData = Object.assign({}, this.state.editData)
        editData.taxonomyName = event.target.value
        this.setState({editData: editData}) 
    }

    handleTaxonomyTagChange = (event) => {
        let editData = Object.assign({}, this.state.editData)
        editData.taxonomyTag = event.target.value
        this.setState({editData: editData}) 
    }

    handleTaxonomyListingSequenceChange = (event) => {
        let editData = Object.assign({}, this.state.editData)
        editData.taxonomyListingSequence = event.target.value
        this.setState({editData: editData}) 
    }

    handleEditorDescriptionUpdate: Function = (editorState) => {
        let editorData = Object.assign({}, this.state.editorData)
        editorData.editorStateRead = editorState
        this.setState({editorData: editorData});
    }

    handleTaxonomyImageLinkChange = (event) => {
        let editData = Object.assign({}, this.state.editData)
        editData.taxonomyImgLink = event.target.value
        this.setState({editData: editData}) 
    }

    handleTaxonomyParentChange = (option) => {
        this.setState(state => {
            return {
                taxonomyChange: true,
                selectedTaxonomyParent : option
            };
        });
    }

    handleProductParentChange = (option) => {
        this.setState(state => {
            return {
                productChange: true,
                selectedProductList : option
            };
        });
    }

    handleTopicParentChange = (option) => {
        this.setState(state => {
            return {
                topicChange: true,
                selectedTopicList : option
            };
        });
    }

    handleAspectParentChange = (option) => {
        this.setState(state => {
            return {
                aspectChange: true,
                selectedAspectList : option
            };
        });
    }

    handleUpdateTaxonomy = (e) => {
        let htmlText = stateToHTML(this.state.editorData.editorStateRead.getCurrentContent())

        if (parseInt(this.props.match.params.type) === 1) {
            if (this.state.editData.taxonomyName === '') {
                return this.setState({errorMsg: 'Please enter the name of the Taxonomy to save the taxonomy'})
            }
        }
        else {
            if ((this.state.editData.taxonomyName === '') || (this.state.editData.taxonomyTag === '') || (this.state.editData.taxonomyImgLink === '') || (this.state.editData.taxonomyListingSequence === '')) {
                return this.setState({errorMsg: 'Please enter the name and tag of the Taxonomy to save the taxonomy'})
            }

            if (this.state.selectedTaxonomyParent.length === 0){
                return this.setState({errorMsg: 'Please select atleast one Parent before updating the resource.'})
            }

            if (parseInt(this.props.match.params.type) === 5) {
                if ((this.state.selectedProductList.length === 0) && (this.state.selectedTopicList.length === 0)){
                     return this.setState({errorMsg: 'Please select atleast one Product OR one Topic to update the taxonomy.'})
                }
            }

            if (htmlText.length < 15){
                return this.setState({errorMsg: 'Description is Mandatory and should have minimum of 15 characters'})
            }                     
        }
        let values
        values = {
            'name': this.state.editData.taxonomyName,
            'tag': this.state.editData.taxonomyTag,
            'img_link': this.state.editData.taxonomyImgLink,
            'listing_sequence': this.state.editData.taxonomyListingSequence,
            'description': htmlText,
            'active': parseInt(this.state.editData.active),
        }

        if (this.state.taxonomyChange === true){
            values = Object.assign({'selected_taxonomies' : this.state.selectedTaxonomyParent}, values)
        }

        if ((this.state.productChange === true) || (this.state.topicChange === true)){
            var myStringArray = this.state.selectedProductList;
            var arrayLength = myStringArray.length;
            let selectedProductString = []
            for (var i = 0; i < arrayLength; i++) {
                selectedProductString.push(parseInt(myStringArray[i].value))
            }

            var myStringTopicArray = this.state.selectedTopicList;
            var topicArrayLength = myStringTopicArray.length;
            let selectedTopicString = []
            for (var i = 0; i < topicArrayLength; i++) {
                selectedTopicString.push(parseInt(myStringTopicArray[i].value))
            }
            values = Object.assign({'data_detail':{'mc_topic_id': selectedTopicString, 'certification_type_id': selectedProductString}}, values)
        }

        api.updateTaxonomyDetails(this.props.user.accessToken, this.props.match.params.taxonomyId, values)
        .then((result) => {
            if (result.status === 'success'){
                this.handleBackAction(e)
            }
            else if(result.status === 'invalid_description'){
                this.setState({errorMsg: `Error occured while updating the ${this.props.match.params.typeName}. Description is too long.`})
            }
            else{
                this.setState({errorMsg: `Error occured while updating the ${this.props.match.params.typeName}. Please try again later.`})
            }
        })
    }

    componentDidMount() {
    	let data = Object.assign({}, this.state.data)
        let editData = Object.assign({}, this.state.editData)
        let editorData = Object.assign({}, this.state.editorData)

        let url = `admin/taxonomy_details/edit/${this.props.match.params.taxonomyId}`
        let newSectionType = parseInt(this.props.match.params.type) - 1
        let url2 = `admin/taxonomy_details/${newSectionType}`
        let url3 = `admin/taxonomy/parent_details/${this.props.match.params.taxonomyId}/${newSectionType}`
        let url4 = 'admin/learning_taxonomy/product/information'

    	return api.getResponse(this.props.user.accessToken, url)
    	.then((result) => {
    		if (result.status === 'success'){
                editData.taxonomyName = result.data.taxonomy.name
                editData.taxonomyTag = result.data.taxonomy.tag
                editData.taxonomyImgLink = result.data.taxonomy.img_link
                editData.taxonomyListingSequence = result.data.taxonomy.listing_sequence
                editData.taxonomyDescription = result.data.taxonomy.description
                let contentValue = convertFromHTML(result.data.taxonomy.description)
                const contentState = ContentState.createFromBlockArray(contentValue);
                editorData.editorStateRead = EditorState.createWithContent(contentState);
                if(result.data.taxonomy.active === true){
                    editData.active = 1
                }
                else if(result.data.taxonomy.active === false){
                    editData.active = 0
                }

                if ((parseInt(this.props.match.params.type) === 3) || (parseInt(this.props.match.params.type) === 5)) {
                    if (result.data.taxonomy.data_detail !== null) {
                        let selectedProductList = result.data.data_detail.certification_type
                        let selectedTopicList = result.data.data_detail.mc_topic
                        this.setState({selectedProductList: selectedProductList, selectedTopicList: selectedTopicList})
                    }
                }
                this.setState({editData: editData, editorData: editorData})
    			if (this.props.match.params.type !== '1'){
	    			api.getResponse(this.props.user.accessToken, url2)
		            .then((result) => {
		                data.taxonomyComboDropDown = result.data
		                this.setState({data: data})
                        if (parseInt(this.props.match.params.type) !== 5) {
    		                api.getResponse(this.props.user.accessToken, url3)
    		                .then((result) => {
    		                	if (result.status === 'success'){
    		                		let selectedTaxonomyParent = result.data
    		                		this.setState({selectedTaxonomyParent: selectedTaxonomyParent})
    		                	}
    		                })
                        }
                        else {
                            let aspectSection = parseInt(this.props.match.params.type) - 2
                            let fetchAspects = `admin/taxonomy_details/${aspectSection}`
                            let fetchAssociatedAspects = `admin/taxonomy/parent_details/${this.props.match.params.taxonomyId}/${3}`
                            api.getResponse(this.props.user.accessToken, url3)
                            .then((result) => {
                                if (result.status === 'success'){
                                    let selectedTaxonomyParent = result.data
                                    api.getResponse(this.props.user.accessToken, fetchAspects)
                                    .then((result) => {
                                        if (result.status === 'success') {
                                            data.aspectComboDropDown = result.data
                                            this.setState({data: data, selectedTaxonomyParent: selectedTaxonomyParent})
                                        }
                                    })
                                }
                            })
                            api.getResponse(this.props.user.accessToken, fetchAssociatedAspects)
                            .then((result) => {
                                if (result.status === 'success'){
                                    let selectedAspectList = result.data
                                    this.setState({data: data, selectedAspectList: selectedAspectList})
                                }
                            })
                        }
                        api.getResponse(this.props.user.accessToken, url4)
                        .then((result) => {
                            if (result.status === 'success') {
                                data.productComboDropDown = result.data.certifications
                                data.topicComboDropDown = result.data.topics
                                this.setState({data: data})
                            }
                        })
		            })
		        }
    		}
    	})
    }

    render() {
    	let handleBackAction = this.handleBackAction
        let handleUpdateTaxonomy = this.handleUpdateTaxonomy
    	let editForm
        let activeComponent = (
        <GridCell span = "12">
          <Select
            onChange={this.handleActiveChange} 
            value={this.state.editData.active}
          >
            <option value = "1">Active</option>
            <option value = "0">Inactive</option>
          </Select>
        </GridCell>
        )

    	if (parseInt(this.props.match.params.type) === 1){
    		editForm = (
                <Grid>
    				<GridCell span = "12">
    					<TextField fullwidth className = 'test_input' label="Name of the Taxonomy" autoComplete="off"  name="taxonomyname" value = {this.state.editData.taxonomyName} style={{ height: '140%' }} onChange = {this.handleTaxonomyNameChange}/>
    				</GridCell>
                    <GridCell span = "12">
                        <TextField fullwidth className = 'test_input' label="Image Link of the Taxonomy" autoComplete="off"  name="taxonomyImgLink" value = {this.state.editData.taxonomyImgLink} style={{ height: '140%' }} onChange = {this.handleTaxonomyImageLinkChange}/>
                    </GridCell>
                    <GridCell span = "12">
                        <TextField fullwidth className = 'test_input' label="Listing Sequence" autoComplete="off"  name="taxonomyListingSequence" value = {this.state.editData.taxonomyListingSequence} style={{ height: '140%' }} onChange = {this.handleTaxonomyListingSequenceChange}/>
                    </GridCell>
                    {activeComponent}
                    <GridCell span = "12">
                        <Typography use="headline7">Description:</Typography>
                        <div className = 'mdc-layout-grid__cell mdc-layout'
                                style={{height: '200px', overflow: 'auto'}}>
                        <GridCell span="12">
                            <Editor
                                editorState={this.state.editorData.editorStateRead}
                                wrapperClassName="demo-wrapper"
                                editorClassName="demo-editor"
                                onEditorStateChange={this.handleEditorDescriptionUpdate}
                                toolbar={{
                                    options:['inline', 'list' ],
                                    link: { inDropdown: true },
                                    inline:
                                        {
                                            options:['bold', 'italic', 'underline']
                                        },
                                }}

                            />
                        </GridCell>
                      </div>
                    </GridCell>
                    <GridCell span = "6">
                        <Button raised style={{ width: '100%' }} onClick={((e) => handleUpdateTaxonomy(e))}>Save</Button>
                    </GridCell>
                    <GridCell span = "6">
                        <Button dense style={{ width: '100%' }} onClick={((e) => handleBackAction(e))}>Cancel</Button>
                    </GridCell>
                    <GridCell span = "12">
                        <StatusMessage error_msg = {this.state.errorMsg} />
                    </GridCell>
                </Grid>
            )
    	}
        else if ((parseInt(this.props.match.params.type) > 1) && (parseInt(this.props.match.params.type) < 5) && (parseInt(this.props.match.params.type) !== 3))
            editForm = (
                <Grid>
                    <GridCell span = "12">
                        <TextField fullwidth className = 'test_input_1' label="Name of the Taxonomy" autoComplete="off"  name="taxonomyname" value = {this.state.editData.taxonomyName} style={{ height: '140%' }} onChange = {this.handleTaxonomyNameChange}/>
                    </GridCell>
                    <GridCell span = "12">
                        <TextField fullwidth className = 'test_input_2' label="Tag of the Taxonomy" autoComplete="off"  name="taxonomytag" value = {this.state.editData.taxonomyTag} style={{ height: '140%' }} onChange = {this.handleTaxonomyTagChange}/>
                    </GridCell>
                    <GridCell span = "12">
                        <TextField fullwidth className = 'test_input' label="Image Link of the Taxonomy" autoComplete="off"  name="taxonomyImgLink" value = {this.state.editData.taxonomyImgLink} style={{ height: '140%' }} onChange = {this.handleTaxonomyImageLinkChange}/>
                    </GridCell>
                    <GridCell span = "12">
                        <TextField fullwidth className = 'test_input' label="Listing Sequence" autoComplete="off"  name="taxonomyListingSequence" value = {this.state.editData.taxonomyListingSequence} style={{ height: '140%' }} onChange = {this.handleTaxonomyListingSequenceChange}/>
                    </GridCell>
                    {activeComponent}
                    <GridCell span = "12">
                        <Typography use="headline7">Description:</Typography>
                        <div className = 'mdc-layout-grid__cell mdc-layout'
                                style={{height: '200px', overflow: 'auto'}}>
                        <GridCell span="12">
                            <Editor
                                editorState={this.state.editorData.editorStateRead}
                                wrapperClassName="demo-wrapper"
                                editorClassName="demo-editor"
                                onEditorStateChange={this.handleEditorDescriptionUpdate}
                                toolbar={{
                                    options:['inline', 'list' ],
                                    link: { inDropdown: true },
                                    inline:
                                        {
                                            options:['bold', 'italic', 'underline']
                                        },
                                }}
                            />
                        </GridCell>
                      </div>
                    </GridCell>
                    <GridCell span = "12">
                        <Reactsel
                                name="taxonomylist"
                                onChange={this.handleTaxonomyParentChange}
                                value={this.state.selectedTaxonomyParent}
                                options={this.state.data.taxonomyComboDropDown}
                                placeholder="--Select Taxonomy Parent--"
                                isMulti>
                        </Reactsel>
                    </GridCell>
                    <GridCell span = "6">
                        <Button raised style={{ width: '100%' }} onClick={((e) => handleUpdateTaxonomy(e))}>Save</Button>
                    </GridCell>
                    <GridCell span = "6">
                        <Button dense style={{ width: '100%' }} onClick={((e) => handleBackAction(e))}>Cancel</Button>
                    </GridCell>
                    <GridCell span = "12">
                        <StatusMessage error_msg = {this.state.errorMsg} />
                    </GridCell>
                </Grid>
            )
        else if (parseInt(this.props.match.params.type) === 5){
             editForm = (
                <Grid>
                    <GridCell span = "12">
                        <TextField fullwidth className = 'test_input_1' label="Name of the Taxonomy" autoComplete="off"  name="taxonomyname" value = {this.state.editData.taxonomyName} style={{ height: '140%' }} onChange = {this.handleTaxonomyNameChange}/>
                    </GridCell>
                    <GridCell span = "12">
                        <TextField fullwidth className = 'test_input_2' label="Tag of the Taxonomy" autoComplete="off"  name="taxonomytag" value = {this.state.editData.taxonomyTag} style={{ height: '140%' }} onChange = {this.handleTaxonomyTagChange}/>
                    </GridCell>
                    <GridCell span = "12">
                        <TextField fullwidth className = 'test_input' label="Image Link of the Taxonomy" autoComplete="off"  name="taxonomyImgLink" value = {this.state.editData.taxonomyImgLink} style={{ height: '140%' }} onChange = {this.handleTaxonomyImageLinkChange}/>
                    </GridCell>
                    <GridCell span = "12">
                        <TextField fullwidth className = 'test_input' label="Listing Sequence" autoComplete="off"  name="taxonomyListingSequence" value = {this.state.editData.taxonomyListingSequence} style={{ height: '140%' }} onChange = {this.handleTaxonomyListingSequenceChange}/>
                    </GridCell>
                    {activeComponent}
                    <GridCell span="12">
                        <GridCell span = "12">
                            <Typography use="headline7">Description:</Typography>
                             <div className = 'mdc-layout-grid__cell mdc-layout'
                                style={{height: '200px', overflow: 'auto'}}>
                          <GridCell span = "12">
                            <Editor
                                editorState={this.state.editData.editorStateRead}
                                wrapperClassName="demo-wrapper"
                                editorClassName="demo-editor"
                                onEditorStateChange={this.handleEditorDescriptionUpdate}
                                toolbar={{
                                    options:['inline', 'list' ],
                                    link: { inDropdown: true },
                                    inline:
                                        {
                                            options:['bold', 'italic', 'underline']
                                        },
                                }}
                            />
                        </GridCell>
                        </div>
                      </GridCell>
                    </GridCell>
                    <GridCell span = "12">
                        <Reactsel
                                name="taxonomylist"
                                onChange={this.handleTaxonomyParentChange}
                                value={this.state.selectedTaxonomyParent}
                                options={this.state.data.taxonomyComboDropDown}
                                placeholder="--Select Taxonomy Parent--"
                                isMulti>
                        </Reactsel>
                    </GridCell>
                    <GridCell span = "12">
                        <Reactsel
                                name="productlist"
                                onChange={this.handleProductParentChange}
                                value={this.state.selectedProductList}
                                options={this.state.data.productComboDropDown}
                                placeholder="--Select Product Product--"
                                isMulti>
                        </Reactsel>
                    </GridCell>
                    <GridCell span = "12">
                        <Reactsel
                                name="topiclist"
                                onChange={this.handleTopicParentChange}
                                value={this.state.selectedTopicList}
                                options={this.state.data.topicComboDropDown}
                                placeholder="--Select MC Parent--"
                                isMulti>
                        </Reactsel>
                    </GridCell>
                    <GridCell span = "12">
                        <Reactsel
                                name="aspectlist"
                                onChange={this.handleAspectParentChange}
                                value={this.state.selectedAspectList}
                                options={this.state.data.aspectComboDropDown}
                                placeholder="--Select Aspect--"
                                isMulti>
                        </Reactsel>
                    </GridCell>
                    <GridCell span = "6">
                        <Button raised style={{ width: '100%' }} onClick={((e) => handleUpdateTaxonomy(e))}>Save</Button>
                    </GridCell>
                    <GridCell span = "6">
                        <Button dense style={{ width: '100%' }} onClick={((e) => handleBackAction(e))}>Cancel</Button>
                    </GridCell>
                    <GridCell span = "12">
                        <StatusMessage error_msg = {this.state.errorMsg} />
                    </GridCell>
                </Grid>
            )
        }
        else if (parseInt(this.props.match.params.type) === 3){
             editForm = (
                <Grid>
                    <GridCell span = "12">
                        <TextField fullwidth className = 'test_input_1' label="Name of the Taxonomy" autoComplete="off"  name="taxonomyname" value = {this.state.editData.taxonomyName} style={{ height: '140%' }} onChange = {this.handleTaxonomyNameChange}/>
                    </GridCell>
                    <GridCell span = "12">
                        <TextField fullwidth className = 'test_input_2' label="Tag of the Taxonomy" autoComplete="off"  name="taxonomytag" value = {this.state.editData.taxonomyTag} style={{ height: '140%' }} onChange = {this.handleTaxonomyTagChange}/>
                    </GridCell>
                    <GridCell span = "12">
                        <TextField fullwidth className = 'test_input' label="Image Link of the Taxonomy" autoComplete="off"  name="taxonomyImgLink" value = {this.state.editData.taxonomyImgLink} style={{ height: '140%' }} onChange = {this.handleTaxonomyImageLinkChange}/>
                    </GridCell>
                    <GridCell span = "12">
                        <TextField fullwidth className = 'test_input' label="Listing Sequence" autoComplete="off"  name="taxonomyListingSequence" value = {this.state.editData.taxonomyListingSequence} style={{ height: '140%' }} onChange = {this.handleTaxonomyListingSequenceChange}/>
                    </GridCell>
                    {activeComponent}
                    <GridCell span = "12">
                        <Typography use="headline7">Description:</Typography>
                         <div className = 'mdc-layout-grid__cell mdc-layout'
                                style={{height: '200px', overflow: 'auto'}}>
                        <GridCell span="12">
                            <Editor
                                editorState={this.state.editorData.editorStateRead}
                                wrapperClassName="demo-wrapper"
                                editorClassName="demo-editor"
                                onEditorStateChange={this.handleEditorDescriptionUpdate}
                                toolbar={{
                                    options:['inline', 'list' ],
                                    link: { inDropdown: true },
                                    inline:
                                        {
                                            options:['bold', 'italic', 'underline']
                                        },
                                }}
                            />
                        </GridCell>
                      </div>
                    </GridCell>
                    <GridCell span = "12">
                        <Reactsel
                                name="taxonomylist"
                                onChange={this.handleTaxonomyParentChange}
                                value={this.state.selectedTaxonomyParent}
                                options={this.state.data.taxonomyComboDropDown}
                                placeholder="--Select Taxonomy Parent--"
                                isMulti>
                        </Reactsel>
                    </GridCell>
                    <GridCell span = "12">
                        <Reactsel
                                name="productlist"
                                onChange={this.handleProductParentChange}
                                value={this.state.selectedProductList}
                                options={this.state.data.productComboDropDown}
                                placeholder="--Select Product Product--"
                                isMulti>
                        </Reactsel>
                    </GridCell>
                    <GridCell span = "12">
                        <Reactsel
                                name="topiclist"
                                onChange={this.handleTopicParentChange}
                                value={this.state.selectedTopicList}
                                options={this.state.data.topicComboDropDown}
                                placeholder="--Select MC Parent--"
                                isMulti>
                        </Reactsel>
                    </GridCell>
                    <GridCell span = "6">
                        <Button raised style={{ width: '100%' }} onClick={((e) => handleUpdateTaxonomy(e))}>Save</Button>
                    </GridCell>
                    <GridCell span = "6">
                        <Button dense style={{ width: '100%' }} onClick={((e) => handleBackAction(e))}>Cancel</Button>
                    </GridCell>
                    <GridCell span = "12">
                        <StatusMessage error_msg = {this.state.errorMsg} />
                    </GridCell>
                </Grid>
            )
        }
    	return (
    		<div>
    			<Grid className="opportunity-list-item">
    				<GridCell span = "1">
                        <Button raised style={{ width: '100%' }} onClick={((e) => handleBackAction(e))}>Back</Button>
                    </GridCell>
    				<GridCell span = "12">
                        <Card style={{padding: '25px'}}>
                            <Typography use="headline5">Edit Taxonomy - {this.props.match.params.typeName}</Typography>
                        </Card>
                    </GridCell>
                    <GridCell span = "6">
                        {editForm}
                    </GridCell>
    			</Grid>
    		</div>
    	)
    }
}

function mapStateToProps({user, admin}) {
  return {
    user,
    admin
  }
}

function mapDispatchToProps() {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(EditTaxonomy);


// WEBPACK FOOTER //
// ./src/views/learning_resource_admin/EditTaxonomy.jsx